<template>
	<section v-if="errored">
		<p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
	</section>
	<section v-else>
		<div v-if="loading" class="d-flex justify-content-center mt-5">
			<div class="spinner-border text-primary" style="width: 5rem; height: 5rem" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>
		<div v-else>
			<OrganisationSelector v-on:passAccountDetails="receiveAccountDetails"/>
			<div class="custom-control custom-switch">
				<input class="custom-control-input" type="checkbox" role="switch" id="showRoute6" v-model="route6Visible">
				<label class="custom-control-label" for="showRoute6">Show route 6</label>
			</div>

			<div class="table-responsive">
				<table class="table table-sm table-striped table-borderless table-hover">
					<thead class="thead-light">
						<tr>
							<th scope="col" class="text-center">Route</th>
							<th scope="col">Job</th>
							<th scope="col">Reference</th>
							<th scope="col">Ref. No</th>
							<th scope="col">Organisation</th>
							<th scope="col">Ordered</th>
							<th scope="col">Expected</th>
							<th scope="col">Zone</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="job in orderedJobs">
							<tr v-if="job.visible" v-on:click="job.zonesVisible = !job.zonesVisible">
								<td :class="[routeColour(job.Route), 'text-center', 'align-middle']">{{ job.Route }}</td>
								<td class="align-middle"><router-link :to="'/ordering/' + job.Job">{{ job.Job }}</router-link></td>
								<td class="align-middle">{{ job.Reference }}</td>
								<td class="align-middle">{{ job.ReferenceID }}</td>
								<td class="align-middle">{{ job.OrganisationName }}</td>
								<td class="align-middle">{{ job.OrderDate }}</td>
								<td class="align-middle">{{ job.EstimatedDispatch }}</td>
								<td class="align-middle">
									<span v-if="job.ZoneHistory">
										<svg class="feather text-info">
											<use xlink:href="../assets/feather-sprite.svg#clock"/>
										</svg>
									</span>
									<span v-else>
										<svg class="feather text-muted">
											<use xlink:href="../assets/feather-sprite.svg#clock"/>
										</svg>
									</span>
									<span> {{ job.Zone | zoneNames }} @ {{ job.ZoneTimestamp | NumberToDescriptiveDate }}</span><br>
									<span v-for="(value,key) in job.ZoneHistory" v-show="job.zonesVisible" class="text-muted row">
										<span class="col">{{ value | ZoneNames }}</span><span class="col">@ {{ key | NumberToDescriptiveDate }}</span>
									</span>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import OrganisationSelector from '../components/OrganisationSelector.vue'
import ZoneNames from '../components/FilterZoneNames'
import CurrencyDecimal from '../components/FilterCurrencyDecimal'
import NumberToDate from '../components/FilterNumberToDate'
import NumberToDescriptiveDate from '../components/FilterNumberToDescriptiveDate'
import RouteNumberToCSS from '../utils/RouteNumberToCSS'

export default {
	name: 'CurrentJobs',
	data () {
		return {
		  info: null,
		  loading: true,
		  errored: false,
		  toggle: false,
		  route6Visible: false
		}
	},
	components: {
		OrganisationSelector
	},
	filters: {
		ZoneNames,
		CurrencyDecimal,
		NumberToDate,
		NumberToDescriptiveDate
	},
	watch: {
		route6Visible: function (newValue, oldValue) {
			_.forEach(this.orderedJobs, (job, index) => {
				if (job.Route == 6) {
					this.orderedJobs[index].visible = newValue
				}
			})
		}
	},
	methods: {
		routeColour: function (value) {
			return RouteNumberToCSS(value)
		},
		toggleRoute6: function () {
			self = this
			this.toggle = !this.toggle
			_.forEach(this.orderedJobs, (job, index) => {
				if (job.Route == 6) {
					this.orderedJobs[index].visible = self.toggle
				}
			})
		},
		receiveAccountDetails: function (value) {
			_.forEach(this.orderedJobs, (job, index) => {
				if ((job.Organisation == value.Organisation) || !value.Organisation) {
					this.orderedJobs[index].visible = true;
				} else {
					this.orderedJobs[index].visible = false;
				}
			})
		}
	},
	computed: {
		orderedJobs: function () {
			return _.orderBy(this.info, 'OrderDate')
		}
	},
  created () {
    axios
      .get('/api/v1/job/outstanding')
      .then(response => {
				let info = response.data;
				info.forEach(i => {
					if (i.ZoneHistory){
						i.ZoneHistory = JSON.parse(i.ZoneHistory);
					}
					i.zonesVisible = false;
					if (i.Route == 6) {
						i.visible = false;
					} else {
						i.visible = true;
					}
				});
        this.info = info;
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
  }
}
</script>
